interface ArtistImageSource {
    id?: string | null;
    name?: string;
    displayText?: string;
    image?: string | null;
}

const artistImageKeys = (artist: ArtistImageSource) => {
    const keys: string[] = [];
    if (artist.id) keys.push(`id:${artist.id}`);
    const name = (artist.displayText || artist.name || '').toLowerCase();
    if (name) keys.push(name);
    return keys;
};

/** Survives closing the influences modal. Saved artists do not store a photo. */
const sharedArtistImages = new Map<string, string>();

export function artistImageMemory() {
    return sharedArtistImages;
}

export function clearArtistImageMemory() {
    sharedArtistImages.clear();
}

export function rememberArtistImages(memory: Map<string, string>, artists: ArtistImageSource[]) {
    artists.forEach((artist) => {
        if (!artist.image) return;
        artistImageKeys(artist).forEach((key) => memory.set(key, artist.image as string));
    });
}

/** Saved artists do not store a photo. Keep the last photo seen for that artist. */
export function artistWithImage<T extends ArtistImageSource>(memory: Map<string, string>, artist: T): T {
    if (artist.image) return artist;
    const image = artistImageKeys(artist).map((key) => memory.get(key)).find(Boolean);
    return image ? { ...artist, image } : artist;
}
